import { FC } from "react";

import { Typography, CtraLayout, Row, Col, Icon, Smile } from "@ctra/components";
import { useTranslation, Enterprise } from "@ctra/i18n";
import { Epoch } from "@ctra/utils";
import { UserProvider } from "@auth";

import styles from "./Welcome.module.less";

const { Text } = Typography;
const { AsyncLayout } = CtraLayout;

/**
 * Get time of the day from the given moment instance
 * @todo maybe find a util for this (though quite coupled with this component)
 * @param dateTime
 */
export const getTimeOfDay = (dateTime: moment.Moment): string => {
  let timeOfDay: string;

  const afternoonSplit = 12;
  const eveningSplit = 17;
  const currentHour = parseFloat(dateTime.format("HH"));

  if (currentHour >= afternoonSplit && currentHour <= eveningSplit) {
    timeOfDay = "afternoon";
  } else if (currentHour >= eveningSplit) {
    timeOfDay = "evening";
  } else {
    timeOfDay = "morning";
  }

  return timeOfDay;
};

/**
 * Welcome the user with a nice message
 * @constructor
 */
export const Welcome: FC = () => {
  const { t } = useTranslation();

  const {
    layouts: {
      dashboard: {
        pageIntro: { title, description }
      }
    }
  } = Enterprise;

  /**
   * Get the time of day for the greetings
   */
  const timeOfDay = getTimeOfDay(Epoch.asMoment(Epoch.now()));

  return (
    <UserProvider>
      {(user, { isLoading }) => (
        <AsyncLayout>
          <Row gutter={[16, 0]} align="middle" className={styles.Wrapper}>
            <Col className={styles.Icon}>
              <Icon component={Smile} className={styles.Smile} />
            </Col>
            <Col flex={1}>
              <Text strong className={styles.Message}>
                {isLoading
                  ? "..."
                  : t<string>(title, {
                      ...user,
                      timeOfDay
                    })}
              </Text>
              <br />
              <Text strong className={styles.Message}>
                {t<string>(description, {
                  timeOfDay
                })}
              </Text>
            </Col>
          </Row>
        </AsyncLayout>
      )}
    </UserProvider>
  );
};
